<template>
    <div :class="[containerClass]">
      <Label
          v-if="label"
          :name="name"
          :label-class="labelClass"
          :required="required"
          :label="label"
      />
      <select :required="required"
              :id="id"
              class="form-select kt_select2"
              :class="selectClass"
              :name="name"
              :value="modelValue"
              data-control="select2"
              :data-search="''+showSearch"
              :data-dropdown-parent="parentId ? '#' + parentId : ''"
              :multiple="multiple  ? 'multiple' : false"
              :disabled="disabled"
              :data-placeholder="placeholder"
              :data-allow-clear="allowClear"
      >
        <slot />
        <template v-if="!$slots.default">
          <option
              v-for="(option, key) in options"
              :key="name+'-option-'+key"
              :value="option"
          >
            {{ option }}
          </option>
        </template>
      </select>
      <div :class="[
            {'d-block': errors && errors.length},
            {'d-none': !(errors && errors.length)},
        ]" class="invalid-feedback">
        {{ errors[0] }}
      </div>
    </div>
  </template>
  
  <script setup>
  import {computed, defineProps, nextTick, onMounted, onUpdated, watch} from "vue";
  import Label from "./Label.vue";
  
  const model = defineModel()
  
  const props = defineProps( {
    name: { type: String, required: true },
    parentId: { type: String, default: '' },
    placeholder: String,
    required: {type:Boolean, default: true},
    label: String,
    showSearch: { type: Boolean, default: true },
    multiple: { type: Boolean, required: true },
    labelClass: String,
    selectClass: {type: String, default: "form-select form-control-lg form-select-solid"},
    containerClass: {
      type: String,
      default: 'col-12 mt-2 mb-3'
    },
    infoText: String,
    disabled: Boolean,
    allowClear: {type:Boolean, default: false},
    options: {type: Array, default: () => []},
    errors: { type: Array, default: () => []}
  })
  
  const id = computed(() => `select-${props.name}-id`)
  
  watch(() => model.value, (value) => {
    if(value) {
      nextTick(() => {
        initSelect()
      })
    }
  })
  
  watch(() => id.value, (value) => {
    nextTick(() => {
      initSelect()
    })
  })
  
  const initSelect = () => {
  
    KTApp.initSelect2()
    const select =  $("#"+id.value)
    select.select2({
      minimumResultsForSearch: props.showSearch ? 2 : Infinity,
      parent: '#' + props.parentId,
      dropdownParent: $('#'+id.value)
    })
    if(props.multiple) {
      select.change((e) => {
        let result = [];
        if(e.target.value) {
          for (let i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
            if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
              result.push(e.target.selectedOptions[i].value);
            }
          }
        }
        model.value = result
      });
    } else {
      select.change((e) => {
        model.value = e.target.value
      });
    }
  }
  
  onMounted(() =>  {
    initSelect()
  })
  
  onUpdated(() => {
    nextTick(() => {
      initSelect()
    })
  })
  
  
  </script>
  <style scoped>
  .select2-container--bootstrap5 .select2-selection--multiple:not(.form-select-sm):not(.form-select-lg) {
      padding-top: calc((2.5rem + 2px - 0.8rem)/ 2);
      padding-bottom: calc((2.5rem + 2px - 0.8rem)/ 2);
  }
  .select2-container .select2-selection--multiple, .kt_select2{
    min-height: 44.89px !important;
  }
  
  .select-container {
    position: relative;
  }
  </style>